export default {
      id: "google-plus-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "./images/icons.svg#google-plus",
      toString: function () {
        return this.url;
      }
    }